var _excluded = ["tabs", "activeTabIndex"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef, useState } from "react";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { IconContainer } from "../../atoms/ProductCategoryTabAtm/ProductCategoryTabAtm.styled";
import TextAtm from "../../atoms/TextAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
var PointerMobile = function PointerMobile(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.654 11.995h-65.4c3.712-.125 10.372-.747 16.366-3.382.97-.426 2.234-.965 3.574-1.537 2.022-.862 4.215-1.797 5.82-2.525 3.831-1.739 6.94-1.582 6.94-1.582s3.11-.157 6.94 1.582c1.606.728 3.798 1.663 5.82 2.525 1.34.572 2.605 1.111 3.575 1.537 5.993 2.635 12.653 3.257 16.365 3.382ZM-.655 12Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h66v12H0z"
  }))));
};
PointerMobile.defaultProps = {
  width: "67",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Pointer = function Pointer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.048 16H4.952c5.681-.208 15.875-1.241 25.048-5.617 1.484-.708 3.42-1.604 5.47-2.553 3.095-1.432 6.451-2.985 8.908-4.195C50.241.747 55 1.008 55 1.008s4.759-.26 10.622 2.627c2.457 1.21 5.813 2.763 8.907 4.195 2.051.949 3.987 1.845 5.471 2.553 9.173 4.376 19.367 5.409 25.048 5.617Z",
    fill: "#fff"
  }));
};
Pointer.defaultProps = {
  width: "110",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { MobileTextContainer, PointerWrapper, Separator, StyledProductCategoryTab, TabsWrapper } from "./ProductCategoryTabsMol.styled";
function ProductCategoryTabsMol(_ref) {
  var tabs = _ref.tabs,
    activeTabIndex = _ref.activeTabIndex,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isMobile = useBreakpoint("small", "medium");
  var pointerOffset = isMobile ? 34 : 55;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    pointerPosition = _useState2[0],
    setPointerPosition = _useState2[1];
  var tabRefs = useRef(new Array(tabs.length).fill(null));
  var observerRef = useRef(null);
  var tabsWrapperRef = useRef(null);
  var icon = tabs[activeTabIndex].icon;
  useEffect(function () {
    var calculatePointerPosition = function calculatePointerPosition() {
      var activeTab = tabRefs.current[activeTabIndex];
      if (activeTab && tabsWrapperRef.current) {
        var newPosition = activeTab.offsetLeft - tabsWrapperRef.current.offsetLeft + activeTab.offsetWidth / 2;
        setPointerPosition(newPosition - pointerOffset);
      }
    };
    observerRef.current = new ResizeObserver(function () {
      calculatePointerPosition();
    });
    var currentTabRefs = tabRefs.current;
    currentTabRefs.forEach(function (tab) {
      var _observerRef$current;
      if (tab) (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.observe(tab);
    });
    return function () {
      var _observerRef$current2;
      currentTabRefs.forEach(function (tab) {
        if (tab && observerRef.current) observerRef.current.unobserve(tab);
      });
      (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 || _observerRef$current2.disconnect();
    };
  }, [activeTabIndex, isMobile, pointerOffset]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabsWrapper, _extends({
    ref: tabsWrapperRef
  }, restProps), tabs.map(function (tab, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: tab.title
    }, /*#__PURE__*/React.createElement(StyledProductCategoryTab, {
      title: tab.title,
      text: tab.text,
      icon: tab.icon,
      outlineColor: tab.outlineColor,
      isActive: index === activeTabIndex,
      onClick: tab.onClick,
      ref: function ref(el) {
        tabRefs.current[index] = el;
      }
    }), index === 0 ? /*#__PURE__*/React.createElement(Separator, null) : null);
  })), /*#__PURE__*/React.createElement(PointerWrapper, {
    $position: pointerPosition
  }, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(Pointer, null)), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, /*#__PURE__*/React.createElement(PointerMobile, null))), activeTabIndex !== 0 ? /*#__PURE__*/React.createElement(MobileTextContainer, null, icon ? /*#__PURE__*/React.createElement(IconContainer, null, icon) : null, tabs[activeTabIndex].text ? /*#__PURE__*/React.createElement(TextAtm, {
    pushSpace: 0,
    typography: "xsmall2"
  }, tabs[activeTabIndex].text) : null) : null);
}
export default ProductCategoryTabsMol;